
import { Component, Inject, OnInit, DOCUMENT } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterState } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { AuthService } from '@app/services';

declare const gtag: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'new-eduhealthcare';

  constructor(
    private _authService: AuthService,
    private titleService: Title,
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit() {
    this.checkUserLogin();
    this.handleRouteEvents();
  }


  checkUserLogin() {
    // Need user idle to be set if there is a logged in user. Is there is one it will handle setting the idle 
    const userLoggedIn = this._authService.getCurrentlyLoggedInUser();

    // If no user is logged in or token is expired make sure token and currentUser are not still saved in storage.
    // Sometimes happens if app closed before logout
    if (!userLoggedIn || userLoggedIn === undefined || this._authService.isTokenExpired()) this._authService.logout();
  }


  handleRouteEvents() {
    try {
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          // console.log('Handling route event triggered.');

          const title = this.getTitle(this.router.routerState, this.router.routerState.root).join(' - ');
          if (title) this.titleService.setTitle(title);

          gtag('event', 'page_view', {
            page_title: event.url,
            page_path: event.urlAfterRedirects,
            page_location: this.document.location.href
          });
        }
      });
    } catch (_err) {
      console.log('Error handling google analytics route events: ', _err);
    }
  }


  getTitle(state: RouterState, parent: ActivatedRoute): string[] {
    const data = [];

    // console.log('Getting title from state: ', state);
    // console.log('Parent: ', parent);

    if (parent && parent.snapshot.data && parent.snapshot.data['title']) {
      data.push(parent.snapshot.data['title']);
    }

    if (state && parent && parent.firstChild) {
      data.push(...this.getTitle(state, parent.firstChild));
    }

    return data;
  }
}
